
<modal #encuestaModal>
	<ng-container title-desc>Sugerencias</ng-container>
	<div class="encuesta">

		<ng-container *ngIf="( preguntaReady$ | async ) && ( encuestaReady$ | async ); else loading">
			<p>¿No está conforme con Comunità? ¿Por qué?</p>

			<form [formGroup]="encuestaForm" autocomplete="off" novalidate>
				<fieldset>
					<ng-container *ngIf="( preguntas$ | async ) as preguntas">
						<ng-container *ngFor="let pregunta of preguntas">

							<div class="form-check__container">
								<div class="form-check">
									<input class="form-check-input" [formControlName]="pregunta.radioControlName" type="radio" [id]="pregunta.radioId" [value]="pregunta.preguntaAbrev" (change)="onRadioChange( $event )">
									<label class="form-check-label" [for]="pregunta.radioId">
										<div>{{ pregunta.pregunta }}</div>
										<input [formControlName]="pregunta.textControlName" type="text" class="form-control" [placeholder]="pregunta.aclaracion"
											[ngClass]="{ 'is-invalid': encuestaForm.controls[ pregunta.textControlName ].status == 'INVALID' }">
									</label>
								</div>
							</div>

						</ng-container>
					</ng-container>

					<div class="mostrar form-check">
						<input class="form-check-input" formControlName="mostrar" type="checkbox" id="mostrar">
						<label class="form-check-label" for="mostrar">Volver a mostrar este formulario al restaurar versión anterior</label>
					</div>
				</fieldset>

				<div *ngIf="isDescDirty && encuestaForm?.errors" class="errors">
					<div *ngIf="encuestaForm?.errors?.descMaxLength">Cantidad máxima permitida 250 caracteres</div>
					<div *ngIf="encuestaForm?.errors?.descRequired">Debe ingresar un texto relacionado con el motivo</div>
				</div>

				<div class="botonera">
					<button class="btn enviar" type="submit" [disabled]="!encuestaForm.valid || !( encuestaReady$ | async )" (click)="onSubmit()" [ngClass]="{ 'cursor-wait': !( encuestaReady$ | async )}">Enviar</button>
					<button class="btn cancelar" type="button" (click)="onClose()">Cancelar</button>
				</div>
			</form>
		</ng-container>

	</div>
</modal>

<!-- Cargando -->
<ng-template #loading>
	<p class="spinner-border text-info"></p>
</ng-template>